// export const url = process.env.REACT_APP_BASE_URL;
export const url = "https://www.bootheesalon.com";

